module.exports = __webpack_public_path__ + "img/banner-22.dc1cbddd.jpg";